import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'TEMA',
  version: 1,
  label: 'Triple Exponential Moving Average',
  pane: 'main',
  category: 'trend',
  series: 'price',
  order: 33,
  inputs: [period('timeperiod', 30)],
  outputs: [line('tema', 'TEMA', COLOR.blue)],
  talib: { functions: ['TEMA'], expr: 'TEMA(close, timeperiod={timeperiod})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => 3 * (timeperiod - 1),
}
export default def
